import { APIRequestLog } from '../models';
import { ModelResource } from './resource';

export class APIRequestLogs extends ModelResource<APIRequestLog> {
  model = APIRequestLog;

  resourcePath = 'v1/api-request-logs';
}
